import { Alert, Flex, Text } from "@fluentui/react-northstar";
import React, { useEffect, useState } from "react";

import { usePaymentRedirect } from "../../actions/usePaymentRedirect";
import CoreConfirmationAnimation from "../../assets/new-external-tab-image.svg";
import { Button } from "../Button";

interface Props {
  actionText?: string;
  onActionClick?: () => void;
  trackingSource: string;
}

export const PaymentRedirectPlaceholder: React.FC<Props> = ({
  onActionClick,
  actionText = "Refresh",
  trackingSource,
}) => {
  const [showWarning, setShowWarning] = useState(false);
  const [paymentUrl, setPaymentUrl] = useState<string>();
  const { generatePaymentLink } = usePaymentRedirect();
  const hideAction = !onActionClick;

  useEffect(() => {
    (async () => {
      const url = await generatePaymentLink(trackingSource);
      setPaymentUrl(url);
    })();
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  const handleOnActionClick = () => {
    onActionClick && onActionClick();
    setShowWarning(true);
  };

  return (
    <Flex column gap="gap.large">
      <Text
        content="Checkout page opened in your browser"
        size="larger"
        weight="bold"
        align="center"
        as="div"
      />
      <img
        src={CoreConfirmationAnimation}
        className="congratulations__success_img"
        alt="Success"
        height={150}
      />
      <Text>
        A page to submit your payment details should have opened in a browser window. If you do not
        see the payment page then please{" "}
        <a
          href={paymentUrl}
          className="brand-link underline"
          target="_blank"
          rel="noopener noreferrer"
        >
          click here
        </a>
        . Once you have completed submitting your payment details{" "}
        {hideAction ? "close this dialog box" : `click the ${actionText} button below`} to continue.
      </Text>
      {!hideAction && (
        <Flex.Item>
          <Flex hAlign="end">
            <Button onClick={handleOnActionClick} content={actionText} primary />
          </Flex>
        </Flex.Item>
      )}
      {showWarning && (
        <p>
          <Alert content="You must complete your checkout" warning />
        </p>
      )}
    </Flex>
  );
};
